import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddGarantieProduitComponent } from "./add-garantie-produit/add-garantie-produit.component";
import { EditGarantieProduitComponent } from "./edit-garantie-produit/edit-garantie-produit.component";
import { GarantieProduitDTO } from "../core/model/garantie-produit/garantie-produit-dto";
import { Produit } from "../core/model/produit";
import { GarantieProduitService } from "../core/service/garantie-produit.service";
import { ProduitService } from "../core/service/produit.service";

@Component({
  selector: "app-garantie-produit",
  templateUrl: "./garantie-produit.component.html",
  styleUrls: ["./garantie-produit.component.scss"],
})
export class GarantieProduitComponent implements OnInit {
  produitId: number;
  garanties: GarantieProduitDTO[];
  produit: Produit;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _garantieProduitService: GarantieProduitService,
    private _produitService: ProduitService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.produitId = params["produitId"];
      this.getProduitById(this.produitId);
      this.findAllByProduitId(this.produitId);
    });
  }

  findAllByProduitId(produitId) {
    this._garantieProduitService.findAllByProduitId(produitId).subscribe(
      (data) => {
        this.garanties = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getProduitById(produitId) {
    this._produitService.getProduitById(produitId).subscribe(
      (data) => {
        this.produit = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddGarantieProduitComponent, {
      centered: true,
    });
    // Contexte filtre (pas l'entité éditée)
    modalRef.componentInstance.produitId = this.produitId;

    modalRef.result.then(
      (data) => {
        // on close
        this.findAllByProduitId(this.produitId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  edit(garantieProduit: GarantieProduitDTO): void {
    const modalRef = this.modalService.open(EditGarantieProduitComponent, {
      centered: true,
    });
    modalRef.componentInstance.produitId = this.produitId;
    modalRef.componentInstance.garantieProduit = garantieProduit;

    modalRef.result.then(
      (updated: GarantieProduitDTO) => {
        if (updated && this.garanties) {
          const index = this.garanties.findIndex((g) => g.id === updated.id);
          if (index !== -1) {
            this.garanties[index] = {
              ...this.garanties[index],
              ...updated,
            };
            this.garanties = [...this.garanties];
            return;
          }
        }
        this.findAllByProduitId(this.produitId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
